import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReversePipe } from '../reverse.pipe';
import { TruncatePipe } from '../truncate.pipe';
import { TruncateArrayPipe } from '../truncate-array.pipe';
import { SafeHtmlPipe } from '../safe-html.pipe';
import { DatexPipe } from '../datex.pipe';
import { StripTagsPipe } from '../striptags.pipe';
import { FirstKeyPipe } from '../firstkey.pipe';

@NgModule({
  declarations: [ReversePipe, TruncatePipe, TruncateArrayPipe, SafeHtmlPipe, StripTagsPipe, DatexPipe, FirstKeyPipe],
  exports: [ReversePipe, TruncatePipe, TruncateArrayPipe, SafeHtmlPipe, DatexPipe, StripTagsPipe, FirstKeyPipe],
  imports: [CommonModule]
})
export class AppPipesModule {}
